import React, { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import useAsyncEffect from 'use-async-effect'
import { useCookies } from 'react-cookie'
import { useMutation } from '@tanstack/react-query'
import axios from 'axios'
import { useLogout } from '../../hooks/useLogout'
import { notification } from '../../components/Notifications'
import { notifyError } from '../../utils/notifyError'
import LoadingPageV2 from '../LoadingPageV2'
import { useAuthenticatedContext } from '../../hooks/AuthenticatedContext'
import ROUTES from '../../consts/paths'

const EdlinkLogin: React.FC = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [cookies, setCookie, removeCookie, updateCookies] = useCookies(['edlink_access_token_exists', 'edlink_refresh_token_exists'])
  const stateKeyEdlink = searchParams.get('state')
  const codeKeyFromEdlink = searchParams.get('code')
  const errorKeyFromEdlink = searchParams.get('error')
  const LOGIN_REDIRECT_URI = `${window.location.origin}/edlink_login`
  const { isAuthed } = useAuthenticatedContext()

  // Use logout without redirecting to login page, so user stays on EdlinkLogin
  const { logOutUser: logOutUserNoRedirect, clearClientState } = useLogout()

  const showErrorForEdlinkFailure = (): void => {
    notification(
      'Edlink SSO failed. Please try logging in again.',
      { variant: 'error' }
    )
  }
  console.log('isAuthed==========================', isAuthed)
  const { mutate } = useMutation({
    mutationKey: ['edlinkSso'],
    mutationFn: async (edlinkCode: string) => {
      // If user is already logged in, log out first
    //   if (isAuthed) {
      await logOutUserNoRedirect()
      //   }
      const response = await axios.post('/api/auth/token', {
        code: edlinkCode,
        redirect_uri: LOGIN_REDIRECT_URI
      })
      return response.data
    },
    onSuccess: (data: any) => {
      localStorage.setItem('authType', 'edlink')
      const urlSearch = data?.email?.split('@')?.[1]
      localStorage.setItem('tenantKey', urlSearch)
      updateCookies()
      window.location.href = '/'
    },
    onError: (error: unknown) => {
      // Surface the backend's error message (e.g. the Edlink-timeout guidance to
      // try manual login / forgot password); fall back to the generic copy.
      // `messageKey: 'error'` reads the backend envelope's `{ error }` field directly
      // (raw axios call, not the interceptor) instead of the generic axios status text.
      notifyError(error, { messageKey: 'error', fallbackMessage: 'Edlink SSO failed. Please try logging in again.' })
      clearClientState()
      navigate(ROUTES.LOGIN, { replace: true })
    }
  })

  useAsyncEffect(async () => {
    if (codeKeyFromEdlink) {
      try {
        mutate(codeKeyFromEdlink)
      } catch (e) {
        console.log(e)
      }
    }
  }, [codeKeyFromEdlink, stateKeyEdlink])

  useEffect(() => {
    if (errorKeyFromEdlink) {
      showErrorForEdlinkFailure()
      clearClientState()
      navigate(ROUTES.LOGIN, { replace: true })
    }
  }, [errorKeyFromEdlink])
  return (
   <LoadingPageV2 />
  )
}

export default EdlinkLogin
